// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-container[data-v-73fb1f66] {\n  height: 100vh;\n  padding-bottom: 1.6rem;\n  box-sizing: border-box;\n  overflow: auto;\n}\n.content-box[data-v-73fb1f66] {\n  background-color: #ffffff;\n  margin-top: 0.26667rem;\n  font-size: 0.37333rem;\n  padding: 0.26667rem;\n}\n.van-row[data-v-73fb1f66] {\n  padding: 0.13333rem 0;\n}\n", ""]);
// Exports
module.exports = exports;
